import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { PageFixer, PageRow } from '@beef/smart-kit';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { AnchorModal, AppBannerView, ExtendedSteps, Faq, FixedActionBar, FormLayout, InfoBannerView, LayoutCard, LayoutServices, LayoutTariffs, LegalInfo, Tabs, TeaserBannerView, Video } from "../components";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
var BLOCKS_BY_TYPE = {
  video: Video,
  legal: LegalInfo,
  faq: Faq,
  teaser: TeaserBannerView,
  appBanner: AppBannerView,
  steps: ExtendedSteps,
  infoBanner: InfoBannerView,
  card: LayoutCard,
  tariffs: LayoutTariffs,
  services: LayoutServices,
  form: FormLayout,
  fixedActionBar: FixedActionBar,
  modal: AnchorModal,
  tabs: Tabs,
  custom: undefined
};
var getComponentByBlock = function getComponentByBlock(block, customComponents) {
  if (block.type === 'custom' && block.name) {
    return customComponents === null || customComponents === void 0 ? void 0 : customComponents[block.name];
  }
  return BLOCKS_BY_TYPE[block.type];
};
var LandingConstructor = function LandingConstructor(_ref) {
  var title = _ref.title,
    blocks = _ref.blocks,
    customComponents = _ref.customComponents;
  return /*#__PURE__*/React.createElement("span", {
    className: cn('container'),
    "data-t-id": "src-main"
  }, title && /*#__PURE__*/React.createElement(PageFixer, null, /*#__PURE__*/React.createElement(Text, {
    className: cn('title'),
    size: "size0-b",
    tagType: "h1",
    "data-t-id": "src-main"
  }, title)), (blocks === null || blocks === void 0 ? void 0 : blocks.length) > 0 && blocks.map(function (block, index) {
    var type = block.type,
      data = block.data,
      background = block.background,
      isFullWidth = block.isFullWidth;
    var Block = getComponentByBlock(block, customComponents);
    if (!Block) return null;
    var isTeaser = type === 'teaser';
    var isForm = type === 'form';
    // NOTE: Full width is sometimes necessary for custom components
    // NOTE: TeaserBanner's full width can't be overriden by design
    var Fixer = isTeaser || isFullWidth || isForm ? React.Fragment : PageFixer;
    var blockSpacersPreset = blocks.length === index + 1 ? 'l' : 'm';
    return /*#__PURE__*/React.createElement(Fixer, _extends({
      key: +index
    }, background && {
      backgroundCustomColor: background
    }), /*#__PURE__*/React.createElement(PageRow, {
      blockSpacersPreset: blockSpacersPreset,
      tagName: "section",
      "data-t-id": "src-main"
    }, /*#__PURE__*/React.createElement(Block, _extends({}, data, {
      blockIndex: index,
      "data-t-id": "src-main"
    }))));
  }));
};
export { LandingConstructor };